import { InvolveCards } from "../Components/InvolveCards";


export default function GetInvolved() {
  return (
    <div className="bg-white ">
      <header className="relative">
        <img
          alt="Get Involved"
          className="w-full h-[400px] object-cover"
          height="400"
          src="/images/Balls.jpeg"
          style={{
            aspectRatio: "988/400",
            objectFit: "cover",
          }}
          width="988"
        />
        <div className="absolute top-0 left-0 right-0 bottom-0  flex items-center justify-center">
          <h2 className="text-6xl font-bold text-white rounded-md bg-[#f97316] px-8 py-4">Get Involved</h2>
        </div>
      </header>
      <section className="container mx-auto py-4 px-4">
        <div className=" ">
            <InvolveCards />
        </div>
      </section>
    </div>
  )
}
